











































































































import Ajax from '../../../lib/ajax'
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CreateUser from './create-user.vue'
import EditUser from './edit-user.vue'
// import CreateUser from './create-user.vue'
// import EditUser from './edit-user.vue'
import PageRequest from '@/store/entities/page-request'
import moment from 'moment'

class PageRoleRequest extends PageRequest {
  OrganizationUnitId: string = null
}

@Component({
  components: { CreateUser, EditUser },
  name: 'departmet',
})
export default class Department extends AbpBase {
  pagerequest: PageRoleRequest = new PageRoleRequest()
  subcomponents: any = ''
  loadingTable: boolean = true
  editModalShow: boolean = false
  createModalShow = false
  showResetModal: boolean = false
  showgoModal: boolean = false
  showModal: boolean = false
  startDate = new Date(1991, 4, 14)
  data = [
    {
      title: 'parent 1',
      // expand: true,
      contextmenu: true,
      children: [
        {
          title: 'parent 1-1',
          // expand: true,
          contextmenu: true,
          children: [
            {
              title: 'leaf 1-1-1',
              contextmenu: true,
            },
            {
              title: 'leaf 1-1-2',
              contextmenu: true,
            },
          ],
        },
        {
          title: 'parent 1-2',
          // expand: true,
          contextmenu: true,
          children: [
            {
              title: 'leaf 1-2-1',
              contextmenu: true,
            },
            {
              title: 'leaf 1-2-1',
              contextmenu: true,
            },
          ],
        },
      ],
    },
  ]
  goForm: any = { ok: null }

  list = [] //table 数据
  NoDatas = '暂无数据'
  columns = [] //table 列
  payload = { id: '' } //table 查询条件
  id = null
  currentRow = null
  treeData = [] //tree 数据
  root = null
  contextData = { children: null, title: '', id: '', displayName: '' }
  modalAdd = false
  node = {
    nodeName: '',
    type: 'add',
  }
  reset = {
    userId: null,
    adminPassword: '',
    newPassword: '',
  }
  nodeRule = {
    nodeName: [{ required: true, message: '节点名不能为空', trigger: 'blur' }],
  }
  get roles() {
    return this.$store.state.user.roles
  }
  ruleValidate = {
    ok: [
      // { required: true, message: '不能为空', trigger: 'blur' },
      {
        validator: (rule, value, callback) => {
          if (value != '' && (value == 'OK' || value == 'oK' || value == 'Ok' || value == 'ok')) {
            callback()
          } else {
            callback(new Error('请输入OK'))
          }
        },
      },
    ],
  }
  showgoModalCancel() {
    this.showgoModal = false
  }
  openModal() {
    this.showModal = true
  }
  async created() {
    this.getColumns()
    await this.$store.dispatch({
      type: 'user/getRoles',
    })
    await this.$store.dispatch({
      type: 'user/getUserFormInitData',
    })
  }
  async confirmReset() {
    const res = await Ajax.post(`/api/services/app/User/ResetPasswordByAdmin?userId=${this.id}`)
    this.showResetModal = false
    if (res.data.result.success) {
      this.$Message.success({
        content: res.data.result.message,
        duration: 15,
      })
    } else {
      this.$Message.error({
        content: res.data.result.message,
      })
    }
  }
  confirmGo() {
    let _this = this
    ;(this.$refs.goform as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Modal.confirm({
          title: this.L('提示'),
          content: this.L('人员离职后，将失去所有权限，不可登录'),
          okText: this.L('离职'),
          cancelText: this.L('取消'),
          onOk: async () => {
            await this.$store.dispatch({
              type: 'user/leaveOffice',
              data: _this.currentRow,
            })
            _this.goForm.ok = ''
            _this.showgoModal = false
            await this.getpage()
          },
        })
      }
    })
  }

  //点击节点
  handleClick(data, e) {
    console.log(data, e, 'xxx')
    if (data[0]) {
      this.contextData = data[0]
      this.payload.id = data[0].id
      this.$store.commit('user/setCurrentPage', 1)
      this.getList()
      console.log(data)
    }
  }
  //点击右键菜单
  handleContextMenu(data) {
    this.contextData = data
    console.log(data)
  }
  //添加子菜单
  handleContextMenuAdd() {
    this.modalAdd = true
    this.node.type = 'add'
  }
  // get roles() {
  //   return this.$store.state.user.roles
  // }
  ok() {
    ;(this.$refs['nodeForm'] as any).validate(async (valid) => {
      if (valid) {
        if (this.node.type == 'add') {
          //添加子节点
          await this.$store.dispatch({
            type: 'department/create',
            data: { parentId: this.contextData.id, displayName: this.node.nodeName },
          })
        } else {
          //编辑当前节点
          await this.$store.dispatch({
            type: 'department/update',
            data: { id: this.contextData.id, displayName: this.node.nodeName },
          })
        }
        this.modalAdd = false
        this.node.nodeName = ''
        this.getTree()
      }
    })
  }
  cancel() {
    this.modalAdd = false
  }
  //编辑节点
  handleContextMenuEdit() {
    this.modalAdd = true
    this.node.type = 'edite'
    this.node.nodeName = this.contextData.displayName
  }
  //删除节点
  handleContextMenuDelete(e) {
    if (this.list.length > 0) {
      this.$Message.warning('该部门下还有人员，请先删除部门人员')
      return
    }
    this.$Modal.confirm({
      title: '提示',
      content: '是否确认删除',
      okText: '是',
      cancelText: '否',
      onOk: async () => {
        await this.$store.dispatch({
          type: 'department/delete',
          data: this.contextData.id,
        })
        this.getTree()
      },
    })
  }
  //获取tree数据
  async getTree() {
    // let respone = await this.$store.dispatch({
    //   type: 'department/getAll',
    //   data: {},
    // })
    let { data } = await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree')
    this.treeData = data.result

    this.getList()
  }
  editeTreeValue(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].children) {
        if (data[i].children.length > 0) {
          data[i].expand = true
        }
        this.editeTreeValue(data[i].children)
      }
    }
  }

  renderContent(h, { root, node, data }) {
    this.root = root
    return h(
      'p',
      {
        domProps: {
          id: data.id,
        },
        style: {
          display: 'inline-block',
          fontSize: '14px',
          width: '100%',
        },
      },
      [
        h('span', [
          h('Icon', {
            props: {
              type:
                data.children && data.children.length > 0 ? 'ios-folder-open' : 'ios-paper-outline',
            },
            style: {
              marginRight: '8px',
              color: '#2d8cf0',
              fontSize: '14px',
            },
          }),
          h('span', data.displayName),
        ]),
      ]
    )
  }

  postComponent(component: any) {
    this.subcomponents = component
  }
  //添加用户
  create() {
    this.createModalShow = true
    this.subcomponents.organiValue(this.payload.id)
  }
  pageChange(page: number) {
    this.$store.commit('user/setCurrentPage', page)
    this.getList()
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit('user/setPageSize', pagesize)
    this.getList()
  }
  getpage() {
    this.$store.commit('user/setCurrentPage', 1)
    this.getList()
  }
  //table列表
  async getList() {
    this.loadingTable = true
    this.pagerequest.maxResultCount = this.pageSize
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize
    this.pagerequest.OrganizationUnitId = this.payload.id
    this.list = []
    await this.$store.dispatch({
      type: 'user/getAll',
      data: this.pagerequest,
    })
    this.list = this.$store.state.user.list
    this.loadingTable = false
  }
  get pageSize() {
    return this.$store.state.user.pageSize
  }
  get totalCount() {
    return this.$store.state.user.totalCount
  }
  get currentPage() {
    return this.$store.state.user.currentPage
  }
  goShow(row) {
    this.currentRow = row
    this.goForm.ok = ''
    this.showgoModal = true
    ;(this.$refs.goform as any).resetFields()
  }
  resetModal(id) {
    this.showResetModal = true
    this.id = id
  }
  resetcancel() {
    this.showResetModal = false
  }
  passwordValid = (rule: any, value: any, callback: any) => {
    let reg =
      /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)(?![a-zA-Z0-9]+$)(?![a-zA-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9\\W_!@#$%^&*`~()-+=]+$)(?![0-9A-Z\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,}$/
    if (!value) {
      callback(new Error('必填项不能为空'))
    } else if (!reg.test(value)) {
      callback(new Error('密码要求长度大于8位，且包含大写字母、小写字母、数字、特殊符号'))
    } else {
      callback()
    }
  }
  resetRule = {
    adminPassword: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
    newPassword: [
      { required: true, message: '必填项不能为空', trigger: 'blur' },
      {
        validator: this.passwordValid,
        message: '密码要求长度大于8位，且包含大写字母、小写字母、数字、特殊符号',
        trigger: 'blur',
      },
    ],
  }

  //获取table列
  getColumns() {
    this.columns = [
      {
        title: '登录账号',
        width: 140,
        key: 'userName',
      },
      {
        title: '姓名',
        width: 140,
        key: 'name',
      },
      {
        title: '岗位',
        width: 140,
        key: 'postText',
      },
      {
        title: '职位',
        width: 140,
        key: 'job',
      },
      {
        title: '所属角色',
        key: 'rolesText',
        tooltip: true,
      },

      {
        title: '是否启用',
        width: 100,
        render: (h, params) => {
          return h('span', params.row.isActive ? '是' : '否')
        },
      },
      {
        title: '锁定状态',
        width: 100,
        render: (h, params) => {
          return h('span', params.row.isShow解锁 ? '锁定' : '未锁定')
        },
      },
      {
        title: '创建时间',
        width: 150,
        key: 'creationTime',
        render: (h, params) => {
          return h(
            'span',
            params.row.creationTime
              ? moment(params.row.creationTime).format('YYYY-MM-DD HH:mm')
              : params.row.creationTime
          )
        },
      },
      /* {
			title:'最后登录时间',
			render:(h,params)=>{
				return h('span',params.row.lastLoginTime?moment(params.row.lastLoginTime).format("YYYY-MM-DD hh:mm"):params.row.lastLoginTime)
			}
		}, */ {
        title: '操作',
        key: 'Actions',
        width: 220,
        render: (h, params) => {
          return h(
            'div',
            {
              style: {
                padding: '5px 0px',
              },
            },
            [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginBottom: '5px',
                  },
                  on: {
                    click: () => {
                      let json = JSON.parse(JSON.stringify(params.row))
                      json.organizationUnitIds = params.row.organizationUnitIds
                      this.$store.commit('user/edit', json)
                      this.editModalShow = true
                    },
                  },
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginBottom: '5px',
                    display: window.abp.session.userId == 1 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.resetModal(params.row.id)
                    },
                  },
                },
                this.L('重置密码')
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginBottom: '5px',
                    display: params.row.isShow解锁 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      /**this.resetModal = true;
								(this.$refs.resetForm as any).resetFields();
								this.reset.userId = params.row.id; */
                      let _this = this
                      this.$Modal.confirm({
                        title: '提示',
                        content: '是否对该账号解除锁定',
                        okText: '是',
                        cancelText: '否',
                        onOk: async () => {
                          await this.$store.dispatch({
                            type: 'user/unlock',
                            data: { userId: params.row.id },
                          })
                          this.$Message.success({
                            content: '解除成功',
                            duration: 10,
                          })
                          this.getList()
                        },
                      })
                    },
                  },
                },
                '解锁'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginBottom: '5px',
                    display: window.abp.session.userId == 1 ? '' : 'none',
                  },
                  on: {
                    click: () => {
                      this.goShow(params.row)
                    },
                  },
                },
                this.L('离职')
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    marginBottom: '5px',
                  },
                  on: {
                    click: async () => {
                      this.$Modal.confirm({
                        title: this.L('提示'),
                        content: this.L('是否确认删除'),
                        okText: this.L('是'),
                        cancelText: this.L('否'),
                        onOk: async () => {
                          await this.$store.dispatch({
                            type: 'user/delete',
                            data: params.row,
                          })
                          await this.getpage()
                        },
                      })
                    },
                  },
                },
                this.L('删除')
              ),
              /* h('Button',{
						props:{
							type:'error',
							size:'small'
						},
						on:{
							click:async ()=>{
								this.$Modal.confirm({
										title:'提示',
										content:'是否确认删除',
										okText:'是',
										cancelText:'否',
										onOk:async()=>{
											await this.$store.dispatch({
												type:'user/delete',
												data:params.row
											})
											await this.getList();
										}
								})
							}
						}
					},'删除') */
            ]
          )
        },
      },
    ]
    this.getTree()
    console.log(this.treeData, '树')
  }
}
